import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam} from '../utils/utils';
import {getLink, listLinks, listConceptModels} from '../utils/utilsConceptModel';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import Buffering from "../components/Buffering"; 



class SelectLink extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: null
        };

        this.dsd = new dsd();

        this.handleChange = this.handleChange.bind(this);
    
    }

    componentDidMount(){

        this.setup();
 
     }
 
     componentDidUpdate(prevProps, prevState){
 
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
 

    setup(){

        let StateChange = {
            renderState: null,
            selectConceptModel: false,
            label: "Link",
            idSelected: "",
            idConceptModel: null,
            onChange: null,
        }

        StateChange.name = getParam('name', this.props);

        if (getParam('label',this.props)){
            StateChange.label = getParam('label',this.props);
        }

        StateChange.selectConceptModel = getParam('selectConceptModel',this.props);
        StateChange.idConceptModel = getParam('idConceptModel', this.props);
        StateChange.idSelected = getParam('value', this.props);

        StateChange.onChange = getParam('onChange', this.props);

        
        if (StateChange.selectConceptModel){
            this.loadConceptModels();
        }

        if (StateChange.idConceptModel){
            this.loadLinks(StateChange.idConceptModel);
        }

        if (StateChange.idSelected){
            this.loadSelectedLink(StateChange.idSelected);
        }

        this.setState(StateChange);



    }

    loadSelectedLink(idLink){

        if (!idLink){
            return;
        }

        this.setState({renderState: "loading"});

        const onLoad = (Link) => {
            const StateChange = {
                SelectedLink: Link,
                renderState: "loaded"
            };
            
            if (Link.ConceptModel){
                StateChange.idConceptModel = Link.ConceptModel._id;
                this.loadLinks(StateChange.idConceptModel);
            }
            
            this.setState(StateChange);
            
        };

        const onFail = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load link"
            });
        };

        getLink(this.dsd, idLink, onLoad, onFail);
        
    };

    loadLinks(idConceptModel){

        if (!idConceptModel){
            return;
        }

        this.setState({renderState: "loading"});

        const onLoad = (links) => {
            this.setState({
                Links: links,
                renderState: "loaded"
            });
        };

        const onError = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load links"
            });
        };

        listLinks(this.dsd, {idConceptModel: idConceptModel}, onLoad, onError);
        
    };


    loadConceptModels(){

        this.setState({renderState: "loading"});

        const onLoad = (conceptModels) => {
            this.setState({
                ConceptModels: conceptModels,
                renderState: "loaded"
            });
        };

        const onError = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load concept models"
            });
        };

        listConceptModels(this.dsd, {}, onLoad, onError);
        
    };



    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            case "idConceptModel":
                this.setState({"idConceptModel":FormFieldValue});
                if (FormFieldValue){
                    this.loadLinks(FormFieldValue);
                }
                break;
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;
                this.setState({"FormData": FormData});
                break;
        };

    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
            case "loaded":

                return(
                    <>                    

                        {this.state.selectConceptModel && this.state.ConceptModels &&
                            <PD.Select label='Select a Concept Model' name='idConceptModel' onChange={this.handleChange} value={this.state.idConceptModel}>
                                {
                                    this.state.ConceptModels.map(
                                        (ConceptModel, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={ConceptModel._id}>{ConceptModel.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }


                        {this.state.Links &&

                            <PD.Select label={this.state.label} name={this.state.name} onChange={this.state.onChange} value={this.state.idSelected}>
                                {
                                    this.state.Links.map(
                                        (Link, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={Link._id}>{Link.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }

                    </>
                )
        }

    }
}


export default function SelectLink_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <SelectLink {...props} navigation={navigation} location={location} params={params} />;
  }
